export default __webpack_public_path__ + "static/media/ketosis_energized@3x.6881c898.jpg";